import React from 'react';

import {
  List,
} from '@mui/material';

import type { AttendContactAbsenceJson } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';

import CustomListItem from '@/components/CustomListItem';
import { AbsenceDate } from '@/domain/attendContact/service/entity/valueObjects/absenceDate';
import { AbsenceReason } from '@/domain/attendContact/service/entity/valueObjects/absenceReason';
import { AbsenceReasonDetailInfection } from '@/domain/attendContact/service/entity/valueObjects/absenceReasonDetailInfection';
import { AbsenceReasonDetailSick } from '@/domain/attendContact/service/entity/valueObjects/absenceReasonDetailSick';
import { Memo } from '@/domain/attendContact/service/entity/valueObjects/memo';
import { toStringDateDisplay } from '@/utils/date';

const AbsenceInfo: React.FC<{
  /** データ */
  data: AttendContactAbsenceJson,
}> = ({ data }) => {
  const {
    absenceDate,
    absenceReason,
    absenceReasonDetailInfection,
    absenceReasonDetailSick,
    memo,
  } = data.data;
  return (
    <>
      <List>
        <CustomListItem
          name={AbsenceDate.label}
          content={toStringDateDisplay(new Date(absenceDate))}
        />
        <CustomListItem name={AbsenceReason.label} content={absenceReason} />
        {absenceReason === '感染症' && absenceReasonDetailInfection && (
          <CustomListItem
            name={AbsenceReasonDetailInfection.label}
            content={absenceReasonDetailInfection}
          />
        )}
        {absenceReason === '病欠' && absenceReasonDetailSick && (
          <CustomListItem
            name={AbsenceReasonDetailSick.label}
            content={absenceReasonDetailSick}
          />
        )}
      </List>
      <p style={{ marginLeft: '12px', color: '#666' }}>{Memo.label}</p>
      <p style={{ marginLeft: '24px' }}>{memo}</p>
    </>
  );
};

export default AbsenceInfo;
